<template>
  <div class="d_head">
      <div class="d_head_nav">
          <div class="content_box">
              <div class="d_nav_logo">
                  <img src="../assets/images/fdsm_logo.png" class="d_nav_logo_img">
              </div>
              <div class="d_nav_menu">
                  <a href="http://www.fdsm.fudan.edu.cn/" target="_blank">管院首页</a> │ <a href="https://www.fdsm.fudan.edu.cn/AboutUs/resources.html" target="_blank">常用资源</a> │ <a href="https://www.fdsm.fudan.edu.cn/AboutUs/contact.html" target="_blank">联络中心</a>
              </div>
              <div class="d_clear"></div>
              <div class="mobile_menu_icon" @click.stop="show = !show">
                  <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" role="img" viewBox="0 0 448 512" class="icon"><path fill="currentColor" d="M436 124H12c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm0 160H12c-6.627 0-12-5.373-12-12v-32c0-6.627 5.373-12 12-12h424c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12z"></path></svg>
              </div>
          </div>
      </div>
      <!-- 手机版占位符，当顶部菜单d_head_nav设为position:fixed时，会脱离文档流，所以需要加个占位符 -->
      <div class="d_head_nav_mobile"></div>
      <div class="d_head_banner"></div>
      <transition name="slide-fade">
        <div v-if="show" class="mobile_menu_box">
            <DepartmentLeftMenu></DepartmentLeftMenu>
        </div>
      </transition>
  </div>
</template>
<script>
import DepartmentLeftMenu from '@/components/DepartmentLeftMenu.vue'
export default {
  components: {
    DepartmentLeftMenu
  },
  computed: {
    departmentName: function () {
      return this.$store.state.CurrDepartName
    },
    pageTitle: function () {
      return this.$store.state.CurrPageTitle
    }
    // ,
    // show: function () {
    //   return this.$store.state.mobileMenuFlag
    // }
  },
  data () {
    return {
      show: false
    }
  }
}
</script>
